import api from './index';

class IntlShippingService {
  fetchShipToLocations() {
    return api.get('/store/shiptolocations', true);
  }

  saveShipToLocations(locations) {
    return api.put('/admin/shiptolocations', locations, true);
  }
}

export default new IntlShippingService();


// WEBPACK FOOTER //
// ./src/app/admin/services/api/IntlShippingService.js